module.exports = __webpack_public_path__ + "static/ognew-1bc24606983a9d32e946e151c528c011.png";